import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './AppLegalFooter.css';
import { LanguageContext } from '../App';
import { translations } from '../utils/translations';

function AppLegalFooter() {
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;

  return (
    <footer className="app-legal-footer">
      <div className="app-legal-links">
        <Link to="/terms" className="app-legal-link">
          {t.legal.termsOfUse}
        </Link>
        <Link to="/privacy" className="app-legal-link">
          {t.legal.privacyPolicy}
        </Link>
        <a href="/delete-account.html" className="app-legal-link">
          {t.legal.deleteAccount}
        </a>
      </div>
      <p className="app-legal-disclaimer">
        {t.legal.attorneyAdvertising}
      </p>
      <p className="app-legal-note">{t.legal.noTracking}</p>
    </footer>
  );
}

export default AppLegalFooter;
